<template>
  <div class="wrapper ">
    <div class="wave">
      <div class="heading">
        <h2 class="roboto-medium-black-32px text-green-700">
          Forgot password?
        </h2>
        <span class="worksans-normal-granite-gray-18px">We’ve got you covered.</span>
      </div>

      <form
        class="reset"
        @submit.prevent="submitForm"
      >
        <span class="text-green-500">Let’s reset your password</span>
        <div class="form-group">
          <label
            class="worksans-normal-fiord-16px"
            for="email"
          >Enter your email</label>
          <input
            v-model="email"
            type="email"
            name="email"
            placeholder="Eg. username@mail.com"
          >
        </div>
        <div class="text">
          We will send you an email to reset your password.
        </div>
        <div class="btn-group">
          <router-link :to="{ name: 'login' }">
            <button
              type="button"
              class="cancel-btn"
            >
              Cancel
            </button>
          </router-link>
          <button
            type="submit"
            class="submit"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
    <teleport to="body">
      <div
        v-if="loader"
        class="loading_log"
      >
        <spin-loading
          loadingstatus=""
          loadingmessage=""
        />
      </div>
    </teleport>
  </div>
</template>

<script>
import SpinLoading from '../SpinLoading'
import { mapActions } from 'vuex'

export default {
    name: 'ForgotPassw',
    components: {
        SpinLoading
    },
    data() {
        return {
            email: '',
            loader: false
        };
    },

    methods: {
        ...mapActions(['resetPasswordMiddlewareAuth']),
        async submitForm() {
            try {
                this.loader = true
                const success = await this.resetPasswordMiddlewareAuth({
                    email: this.email,
                });
                if (!success) {
                    throw 'Something went wrong. Please try again later'
                }
                this.loader = false

                await this.$alert(
                    'You should receive a email soon if there is an associated account',
                    'Email sent',
                    'success',
                    {
                        confirmButtonText: 'Got it!'
                    }
                );
                this.$router.push('login');
            } catch (error) {

                this.loader = false
                await this.$alert(
                    'The provided email is not registered with us. Please check your input',
                    'Email not recognized',
                    'error');
            }
        },
    },
};
</script>

<style scoped>
.wrapper {
    margin-top: 2rem;
    padding: 1rem;
    display: flex;
    /* flex-direction: column; */
    justify-content: center;
}

.heading {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.heading>h2 {
    padding-top: 40px;
    padding-bottom: 4px;
}

.heading>span {
    padding-bottom: 64px;
}

.reset {
    background: #ffffff;
    border: 1px solid #f9f9f9;
    box-sizing: border-box;
    box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    padding: 40px 60px;
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: 120px;
}

.reset>span {
    font-family: Roboto;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: #333333;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-group>input {
    height: 52px;
    background: #ffffff;
    min-width: 460px;
    border: 1px solid #cbd5e1;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 18px 0 18px 16px;
    margin-bottom: 8px;
    margin-top: 8px;
}

.form-group>input:focus {
    border: 1px solid var(--djuli-primary-color);
    outline: none;
    color: var(--storm-gray);
    font-size: 14px;
}

.form-group>input::placeholder {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #94a3b8;
}

.text {
    font-family: Work Sans;
    font-size: 12px;
    line-height: 14px;
    color: #0f172a;
    padding-bottom: 2rem;
}

button {
    cursor: pointer;
    border: none;
    width: 98px;
    height: 49px;
    font-family: Roboto;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
    border-radius: 5px;
}

.cancel-btn {
    background-color: #fff;
    margin-right: 6px;
    color: var(--djuli-primary-color);
    border: 1px solid var(--djuli-primary-color);
}

.submit {
    background-color: var(--djuli-primary-color);
    color: #fff;
    box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.12);
}

.wave {
    /* background-image: url("../../../../assets/img/wave.svg"); */
    background-size: 100% 100%;
}

.success-class-verifcation-pending {
    padding: 0.25rem;
    font-family: "Inter";
    background: #6ea516;
    font-size: 12px;
    color: white;
    display: flex;
    font-weight: 600;
    flex-direction: row;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    margin-top: 1rem;
    opacity: 0.9;
}

.warning_icon {
    width: 1.5rem;
    margin-right: 10px;
}
</style>
